<template>
  <div class="accident-party">
    <div
      v-if="!isDisabled.value"
      class="party-controller"
    >
      <span
        type="text"
        class="partyBtn btn1"
        @click="addParty"
      >
        新增伤员
      </span>
      <span
        type="text"
        class="partyBtn btn2"
        @click="deleteParty"
      >
        删除伤员
      </span>
    </div>
    <el-tabs
      :value="activeInjured"
      :class="{
        'current-faild': validFaildIndexs.includes(activeInjured * 1)
      }"
      @input="$emit('update:activeInjured', $event)"
    >
      <el-tab-pane
        v-for="(party, index) in injuredList"
        :key="index"
        :name="index + ''"
      >
        <template #label>
          <span :class="{ 'valid-faild': validFaildIndexs.includes(index) }">{{
            "伤者信息-" +
              (index + 1) +
              (validFaildIndexs.includes(index) ? "*" : "")
          }}</span>
        </template>
        <injurePhotos
          v-if="checkListData.includes('3')"
          :injured-partys="injuredList"
        />
        <injuredForm
          ref="injuredForm"
          :party="party"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import injuredForm from './injuredForm';
import injurePhotos from "./injurePhotos";
export default {
  components: { injuredForm,injurePhotos },
  inject: { 
    isDisabled: { default: () => ({ value: false }) },
    checkList: { default: () => [] } 
  },
  props: {
    injuredList: {
      type: Array,
      required: true
    },
    activeInjured: {
      type: String,
      default:'0'
    }
  },
  data() {
    return {
      validFaildIndexs: []
    };
  },
  watch: {
    injuredList: {
      immediate: true,
      handler(newVal) {
        if (!newVal.length) {
          this.injuredList.push({applicationFormType:0});
        }
      }
    }
  },
  computed:{
    checkListData() {
      return this.checkList();
    }
  },
  methods: {
    validate() {
      this.validFaildIndexs = [];
      return Promise.all(
        this.$refs.injuredForm.map((injuredForm, index) =>
          injuredForm.validate().catch(err => {
            this.validFaildIndexs.push(index);
            throw err;
          })
        )
      ).then(() => {
        if (this.validFaildIndexs.length > 0) {
          this.$emit('update:activeInjured', this.validFaildIndexs[0] + '');
        }
      });
    },
    addParty() {
      this.$emit(
        'update:activeInjured',
        this.injuredList.push({}) - 1 + ''
      );
    },
    deleteParty() {
      if (this.injuredList.length < 2) {
        return;
      }
      // 删除最后一个当事人的情况，tab前移
      const lastIndex = this.injuredList.length - 2;
      const activeIndex = this.activeInjured * 1;
      if (activeIndex > lastIndex) {
        this.$emit('update:activeInjured', lastIndex + '');
      }
      let deleteIsFaild = false;
      this.validFaildIndexs = this.validFaildIndexs.reduce((acc, cur) => {
        if (cur === activeIndex) {
          deleteIsFaild = true;
          return acc;
        }
        if (cur > activeIndex && deleteIsFaild) {
          acc.push(cur - 1);
        } else {
          acc.push(cur);
        }
        return acc;
      }, []);
      this.injuredList.splice(activeIndex, 1);
    }
  }
};
</script>
<style lang="scss">
.accident-party {
  position: relative;
  padding:0 15px;
  .el-tabs__nav-scroll {
    margin-right: 180px;
  }
  .el-tabs__nav-next {
    right: 180px;
  }

  .party-controller {
    position: absolute;
    right: 0;
    top: 30px;
    padding-left: 20px;
    z-index: 5;
    .partyBtn {
      display: inline-block;
      width: 160px;
      height: 48px;
      line-height: 48px;
      border-radius: 4px;
      text-align: center;
      cursor: pointer;
    }
    .btn1 {
      color: #0EBD35;
      background: rgba(14, 189, 53, 0.1);
      border: 1px solid #0EBD35;
      margin-right: 15px;
    }
    .btn2 {    
      color: #FF7D00;
      background: rgba(255, 125, 0, 0.1);
      border: 1px solid #FF7D00;
    }
  }

  .current-faild {
    .el-tabs__active-bar {
      background: #ff4949;
    }
  }
  .valid-faild {
    color: #ff4949;
  }
}
</style>
